import React, { useEffect, useState, useRef } from "react";
import Icon from "./Icon";

const WHATSAPP_URL =
  "https://wa.me/919699594988?text=" +
  encodeURIComponent(
    "Hello, I'm interested in your towel products.\nCompany Name:\nCountry:\nProduct:\nEstimated Quantity:\nPlease share your pricing and lead time."
  );

const MAIL_URL =
  "mailto:info@kunovaimpex.com?subject=" +
  encodeURIComponent("Inquiry for Terry Towels") +
  "&body=" +
  encodeURIComponent(
    "Dear Kunova Impex,\n\nWe are interested in sourcing your textile products.\n\nCompany:\nCountry:\nProduct:\nQuantity:\nCustomization:\n\nPlease share pricing and lead time.\n\nRegards,"
  );

export default function FloatingContact() {
  const [idle, setIdle] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    const kick = () => {
      setIdle(false);
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setIdle(true), 2000);
    };
    kick();
    window.addEventListener("scroll", kick, { passive: true });
    window.addEventListener("mousemove", kick, { passive: true });
    window.addEventListener("touchstart", kick, { passive: true });
    return () => {
      window.removeEventListener("scroll", kick);
      window.removeEventListener("mousemove", kick);
      window.removeEventListener("touchstart", kick);
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  return (
    <div className={`floaters ${idle ? "is-idle" : ""}`} data-testid="floating-contact">
      <a
        href={WHATSAPP_URL}
        className="whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="floating-whatsapp"
      >
        <Icon name="whatsapp" size={24} />
      </a>
      <a
        href={MAIL_URL}
        className="email"
        aria-label="Email Kunova Impex"
        data-testid="floating-email"
      >
        <Icon name="mail" size={22} />
      </a>
    </div>
  );
}
